import GrmCalculator from './index';

const GrmCalculatorBlock = {
  Component: GrmCalculator,
  BlockRenderer: () => <GrmCalculator />,
  metadata: {
    name: 'rentals/grm-calculator',
    title: 'Gross Rent Multiplier Calculator',
    description: '',
    icon: 'businessperson',
    keywords: ['grm', 'gross rent multiplier', 'calculator', 'rentals'],
    supports: {
      customClassName: false,
      html: false,
    },
    category: 'more',
    attributes: {},
  },
};

export default GrmCalculatorBlock;
